import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

// Demo users — in production replace with a real backend auth call
const USERS = [
  { id: 1, name: 'Rami Haddad',    email: 'pm@constructpro.app',      password: 'pm1234',    role: 'pm',      avatar: 'RH', title: 'Project Manager' },
  { id: 2, name: 'Jad Mansour',    email: 'eng@constructpro.app',     password: 'eng1234',   role: 'engineer',avatar: 'JM', title: 'Site Engineer' },
  { id: 3, name: 'Layla Khoury',   email: 'admin@constructpro.app',   password: 'admin1234', role: 'admin',   avatar: 'LK', title: 'Administrator' },
  { id: 4, name: 'Georges Nassar', email: 'viewer@constructpro.app',  password: 'view1234',  role: 'viewer',  avatar: 'GN', title: 'Client / Viewer' },
];

export const PERMISSIONS = {
  admin:    { canCreate: true,  canEdit: true,  canDelete: true,  canApprove: true,  canExport: true,  canManageUsers: true  },
  pm:       { canCreate: true,  canEdit: true,  canDelete: false, canApprove: true,  canExport: true,  canManageUsers: false },
  engineer: { canCreate: true,  canEdit: true,  canDelete: false, canApprove: false, canExport: true,  canManageUsers: false },
  viewer:   { canCreate: false, canEdit: false, canDelete: false, canApprove: false, canExport: true,  canManageUsers: false },
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('cp_user')); } catch { return null; }
  });

  const login = (email, password) => {
    const found = USERS.find(u => u.email.toLowerCase() === email.toLowerCase() && u.password === password);
    if (found) {
      const { password: _, ...safe } = found;
      setUser(safe);
      localStorage.setItem('cp_user', JSON.stringify(safe));
      return { ok: true };
    }
    return { ok: false, error: 'Invalid email or password.' };
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('cp_user');
  };

  const can = (action) => {
    if (!user) return false;
    return PERMISSIONS[user.role]?.[action] ?? false;
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, can }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }
